/**
 * @desc getResource
 */
const URL = "/rantion-ucenter";
import http, { updateResponse } from "@/http";
export function request(body: defs.ucenter.LoginExchangeDto, options?: any) {
  return updateResponse(
    http(URL + `/load/resource`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
